import * as Yup from 'yup';

export const terminateAgreementValidationSchema = ({ t }) => {
  return Yup.object().shape({
    reason: Yup.string().optional(),
    terms: Yup.boolean().oneOf([true]).required(),
  });
};
